import { render, staticRenderFns } from "./AuditCount.vue?vue&type=template&id=136a7c50&scoped=true&"
import script from "./AuditCount.vue?vue&type=script&lang=ts&"
export * from "./AuditCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a7c50",
  null
  
)

export default component.exports